class ConnectionStatus {
    constructor(serverStatus) {
        this.serverStatus = serverStatus;
    }

    translate(t) {
        return t(`settings.amqp.connection-status.${this.serverStatus.toLowerCase().replace(/_/g, '-')}`);
    }

    is(connectionStatus) {
        return connectionStatus === this;
    }
}

export const CONNECTED = new ConnectionStatus('CONNECTED');
export const DISCONNECTED = new ConnectionStatus('DISCONNECTED');

export const getConnectionStatus = (serverStatus) => {
    let result = null;
    switch (serverStatus) {
        case 'CONNECTED':
            result = CONNECTED;
            break;
        case 'DISCONNECTED':
            result = DISCONNECTED;
            break;
        default:
            throw new Error(`Unknown connection status: ${serverStatus}`);
    }
    return result;
};

export const getAllConnectionStatuses = () => [
    CONNECTED,
    DISCONNECTED,
];
